import { useOne, useShow } from '@refinedev/core';
import { Show } from '@refinedev/antd';
import { theme } from 'antd';
import type {
  OrganizationOut,
  PublisherListOut,
} from '@/api/generated/schemas';
import { bareShowContentProps } from '@/components/common/show/shared';
import { useShowTab } from '@/components/common/show/useShowTab';
import { useRecordDocumentTitle } from '@/hooks/useRecordDocumentTitle';
import { CONTRACT_DEFAULT_TAB, CONTRACT_SHOW_TABS } from '../constants';
import type { ContractOut } from '../constants';
import { ContractShowHeader } from './ContractShowHeader';
import { ContractGeneralTab } from './ContractGeneralTab';

export const ContractShow = () => {
  const { token } = theme.useToken();
  const { query } = useShow<ContractOut>({
    resource: 'tenancy.contracts',
  });
  const { data, isLoading } = query;
  const record = data?.data;

  const { result: organization } = useOne<OrganizationOut>({
    resource: 'tenancy.organizations',
    id: record?.organization_id ?? 0,
    queryOptions: { enabled: record?.organization_id != null },
  });

  const { result: publisher } = useOne<PublisherListOut>({
    resource: 'user_catalog.publishers',
    id: record?.publisher_id ?? 0,
    queryOptions: { enabled: record?.publisher_id != null },
  });

  useRecordDocumentTitle(
    'tenancy.contracts',
    record && `${organization?.name ?? record.organization_id}`
  );

  const [activeTab, onTabChange] = useShowTab(
    CONTRACT_SHOW_TABS,
    CONTRACT_DEFAULT_TAB
  );

  return (
    <Show isLoading={isLoading} contentProps={bareShowContentProps}>
      {record && (
        <>
          <ContractShowHeader
            record={record}
            organization={organization}
            publisher={publisher}
            activeTab={activeTab}
            onTabChange={onTabChange}
          />
          <div style={{ marginTop: token.margin }}>
            {activeTab === 'general' && (
              <ContractGeneralTab
                record={record}
                organization={organization}
                publisher={publisher}
              />
            )}
          </div>
        </>
      )}
    </Show>
  );
};
